import CustomNumber from 'designer/component/element/Number'
import ControlWrapper from './ControlWrapper'

const NumberControl = (props) => {
  return <ControlWrapper {...props} Component={CustomNumber} />
}

export default NumberControl
